<template>
    <div>
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>            
        </div>
        <div class="cont-box">
            <img class="icon" src="@/assets/me-succeed.png" alt="">
            <div class="text">你已提交提现申请</div>
            <div class="btn-box">
                <button class="btn" type="button" @click="goBack">返回</button>
            </div>            
        </div>
    </div>
</template>
<script>
import VueQriously from 'vue-qriously'
export default {
    name: 'chongbi',
    data () {
        return {
                
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1);
        }       
    }        
}
</script>
<style scoped>    
    .head{
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        height: .8rem;
        font-size: .3rem;
        line-height: .8rem;
        background: #0e1530;
        text-align: center;
    }    
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .18rem;
        width: .24rem;
        height: .44rem;                
    }
    .cont-box{
        position: absolute;
        left: 0;
        top: .8rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .3rem;             
        background: #0e1530;
        box-sizing: border-box;
        text-align: center;
        overflow-y: auto;
    } 
    .cont-box .icon{
        margin-top: 1.36rem;
        width: 1.44rem;
        height: 1.44rem;
    } 
    .cont-box .text{
        margin-top: .64rem;
    }   
    .cont-box .btn-box{
        position: absolute;
        left: 0;
        bottom: .32rem;
        width: 100%;
        padding: 0 .3rem; 
        box-sizing: border-box;       
    }
    .cont-box .btn{
        width: 100%;              
        height: .78rem;        
        color: #fff;        
        border-radius: 4px;
        background: #7d58c6;
    }    
</style>


// WEBPACK FOOTER //
// src/pages/txcg.vue